import type {
  CreateFriendRequest,
  Friend,
  FriendDetail,
  MergeFriendRequest,
  SetFriendEmojiRequest,
  UpdateFriendRequest,
} from "@boo/shared";
import { request } from "./apiClient";

export async function fetchFriends(): Promise<Friend[]> {
  return request<Friend[]>("/friends");
}

export async function fetchFriend(id: string): Promise<FriendDetail> {
  return request<FriendDetail>(`/friends/${id}`);
}

export async function createFriend(
  payload: CreateFriendRequest,
): Promise<Friend> {
  return request<Friend>("/friends", { method: "POST", data: payload });
}

export async function updateFriend(
  id: string,
  payload: UpdateFriendRequest,
): Promise<Friend> {
  return request<Friend>(`/friends/${id}`, { method: "PATCH", data: payload });
}

export async function deleteFriend(id: string): Promise<void> {
  await request<void>(`/friends/${id}`, { method: "DELETE" });
}

export async function mergeFriend(
  id: string,
  payload: MergeFriendRequest,
): Promise<Friend> {
  return request<Friend>(`/friends/${id}/merge`, {
    method: "POST",
    data: payload,
  });
}

export async function setFriendEmoji(
  id: string,
  emoji: string,
): Promise<Friend> {
  return request<Friend>(`/friends/${id}/avatar/emoji`, {
    method: "PUT",
    data: { emoji } satisfies SetFriendEmojiRequest,
  });
}

export async function uploadFriendAvatar(
  id: string,
  file: Blob,
): Promise<Friend> {
  const formData = new FormData();
  formData.append("file", file, "avatar");
  return request<Friend>(`/friends/${id}/avatar`, {
    method: "POST",
    data: formData,
  });
}

export async function removeFriendAvatar(id: string): Promise<Friend> {
  return request<Friend>(`/friends/${id}/avatar`, { method: "DELETE" });
}

/** The photo needs the auth header, so it is fetched as a blob for an <img>. */
export async function fetchFriendAvatarUrl(
  id: string,
  version: number,
): Promise<string> {
  const blob = await request<Blob>(`/friends/${id}/avatar`, {
    responseType: "blob",
    params: { v: version },
  });
  return URL.createObjectURL(blob);
}
